
import { Button } from "@/components/ui/button";
import { useTimedAccess } from "@/context/TimedAccessContext";
import { useAuth } from "@/context/AuthContext";
import { Timer } from "lucide-react";
import { useLocation } from "react-router-dom";
import { trackButtonClick } from "@/utils/tracking";
import { ENABLE_FREE_ACCESS } from "@/utils/freeAccessConfig";

const FreeAccessNavButton = () => {
  const { hasFreeAccess, startFreeAccess } = useTimedAccess();
  const { isSubscribed } = useAuth();
  const location = useLocation();

  if (!ENABLE_FREE_ACCESS) {
    return null;
  }
  
  // Don't show button if user is already subscribed or has active free access
  if (isSubscribed || hasFreeAccess) {
    return null;
  }
  
  // Check if free access was previously used
  const hasUsedFreeAccess = localStorage.getItem("helloml_free_access_used") === "true";
  
  if (hasUsedFreeAccess) {
    return null;
  }
  
const handleStartFreeAccess = () => {
  // Track the button click
  trackButtonClick("get_free_access_nav_button");

  // Pass the current location as the redirect URL
  startFreeAccess(location.pathname);
};
  
  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={handleStartFreeAccess}
      className="mr-2"
    >
      <Timer className="mr-1 h-4 w-4" />
      Get Free Access
    </Button>
  );
};

export default FreeAccessNavButton;
